export default __webpack_public_path__ + "static/media/Pay-per-click-2.ba328bcc.png";